<template>
	<div class="_create-boarding _modal bg-white">
		<div
			class="
				_modal__content
				px-12
				py-6
				flex flex-col
				items-center
				justify-center
			"
		>
			<div>
				<img
					src="@/assets/images/illustrations/warning.png"
					alt="Luca Education"
					title="Luca Education"
					height="60"
					width="60"
				/>
			</div>
			<div
				class="
					_modal__content__title
					text-neutral-700
					font-semibold
					text-2xl
					mt-5
					text-center
				"
			>
				Bạn có chắc chắn muốn thoát?
			</div>
			<div class="text-center text-neutral-500 mt-2">
				Tài liệu bạn đang soạn chưa được lưu. <br />
				Bạn có muốn lưu bản nháp trước khi thoát?
			</div>
		</div>
		<div
			class="
				_modal__footer
				px-12
				py-6
				bg-neutral-50
				flex flex-nowrap
				items-center
			"
		>
			<button
				type="button"
				class="
					button-p
					text-center
					mr-3
					bg-none
					shadow-none
					text-neutral-500
					hover:text-neutral-700
				"
				@click="$emit('close')"
			>
				Thoát không lưu
			</button>
			<button
				type="button"
				class="button-p text-center whitespace-nowrap"
				:disabled="inProgress"
				@click="$emit('submit')"
			>
				Lưu bản nháp
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CloseConfirm',

	props: {
		inProgress: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
